import React, { Component } from "react";
import Select from "react-select";
import { helperFunctions as HF } from "../../helper/helperFunctions";
import { customSelectStyles } from "../ThemeComponents/selectStyles";
import { withRouter } from "react-router-dom";

class User extends Component {
    constructor(props) {
        super(props);

        this.state = {
            user: {
                user_name: "",
                password: "",
                password_confirmation: "",
                role_id: '',
                role: '',
            },
            states: [],
            submitted: false,
            hidePasswords: 'false'
        };
        this.onChange = this.onChange.bind(this);
        this.contactRoleChangeHandler = this.contactRoleChangeHandler.bind(
            this
        );
    }

    componentDidMount() {
        this.setState(prevState => ({
            ...prevState,
            user: {
                ...prevState.user,
                ...this.props.contactProp.user
            },
            hidePasswords: this.props.hidePasswords
        }), () => {
            if (this.props.rolesProp && this.props.rolesProp.length === 1) {
                this.setState(prevState => ({
                    user: {
                        ...prevState.user,
                        role_id: this.props.rolesProp[0].value,
                        role: this.props.rolesProp[0].label,
                    }
                }));
            }
        });
    }

    onChange(e) {
        this.setState({
            user: {
                ...this.state.user,
                [e.target.name]: e.target.value
            }
        });
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.user !== prevState.user) {
            this.props.returnState({
                user: this.state.user
            });
        }
    }

    contactRoleChangeHandler(e) {
        this.setState({
            user: {
                ...this.state.user,
                role_id: e.value,
                role: e.label
            }
        });
    }

    render() {
        const {
            user_name,
            password,
            password_confirmation,
            role_id
        } = this.state.user;
        return (
            <React.Fragment>
                <div className="mt-md fieldWithIcon">
                    <span className="fieldIcon emailIcon"></span>
                    <input
                        type="text"
                        name="user_name"
                        autoComplete="off"
                        className="form-control"
                        placeholder="Email"
                        value={user_name}
                        onChange={this.onChange}
                    />
                    {this.props.requiredField.user_name && (
                        <span className="customMsg">
                            {this.props.validatorInstance.message(
                                "Email",
                                user_name,
                                ["required"]
                            )}
                        </span>
                    )}
                </div>

                {this.state.hidePasswords !== 'true' &&

                    <React.Fragment>
                        <div className="mt-md fieldWithIcon">
                            <span className="fieldIcon lockIcon"></span>
                            <input
                                type="password"
                                name="password"
                                autoComplete="new-password"
                                className="form-control"
                                placeholder="Password"
                                value={password}
                                onChange={this.onChange}
                            />
                        </div>
                        <div className="mt-md fieldWithIcon">
                            <span className="fieldIcon keyIcon"></span>
                            <input
                                type="password"
                                name="password_confirmation"
                                className="form-control"
                                placeholder="Confirm Password"
                                value={password_confirmation}
                                onChange={this.onChange}
                            />
                        </div>
                    </React.Fragment>
                }

                {this.props.rolesProp && (
                    <div className="mt-md fieldWithIcon text-capitalize">
                        <Select
                            styles={customSelectStyles}
                            value={HF.returnLabelWithValue(
                                role_id,
                                this.props.rolesProp
                            )}
                            onChange={this.contactRoleChangeHandler}
                            options={this.props.rolesProp || []}
                            isSearchable={true}
                            name={"role_id"}
                            isMulti={false}
                            placeholder={"Select Role"}
                            isClearable={false}
                        />
                        <span className="customMsg">
                            {this.props.validatorInstance.message(
                                "Role",
                                role_id,
                                this.props.requiredField.role_id
                            )}
                        </span>
                    </div>
                )}
            </React.Fragment>
        );
    }
}

export default withRouter(User);



// WEBPACK FOOTER //
// ./src/components/ThemeComponents/User.jsx